import React from 'react';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';
import styles from './NiraLogo.module.scss';

interface NiraLogoProps {
  className?: string;
  isNira?: boolean;
}

export const NiraLogo = ({ className }:NiraLogoProps) => (
  <div className={classnames(className, styles.logo)}>
    <NavLink to={`/`}>
      <svg width="34" height="34" viewBox="0 0 34 34" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient x1="14.717%" y1="15.142%" x2="116.004%" y2="118.739%" id="logo_svg__a"><stop stopColor="#9287FE" offset="0%"/><stop stopColor="#10D5C9" offset="100%"/></linearGradient></defs><g fill="none" fillRule="evenodd"><rect fill="url(#logo_svg__a)" width="34" height="34" rx="17"/><path d="M22.153 25.095c.485 0 .954-.032 1.407-.095.453-.064.785-.127.996-.191v-9.956c0-1.866-.643-3.324-1.929-4.374-1.285-1.05-3.119-1.574-5.5-1.574-1.328 0-2.535.159-3.62.477-1.086.318-1.987.731-2.703 1.24a3.848 3.848 0 00-.996.986c-.242.361-.364.827-.364 1.4v9.543c0 .53.069.96.206 1.288.137.328.332.588.585.78.253.19.564.317.932.38.37.064.785.096 1.25.096.484 0 .953-.032 1.406-.095.453-.064.785-.127.996-.191V13.771a3.14 3.14 0 011.059-.477 4.98 4.98 0 011.248-.159c.633 0 1.133.154 1.502.462.369.307.553.79.553 1.447v7.507c0 .53.069.96.206 1.288.137.328.332.588.585.78.253.19.563.317.932.38.37.064.785.096 1.249.096z" fill="#FFF" fillRule="nonzero"/></g></svg>
    </NavLink>
  </div>
);

export default NiraLogo;
